import styled from 'styled-components';
import { Button } from '../../globalStyles';
import background from '../../assets/background.jpeg'
import backgroundHero from '../../assets/backgroundHero.jpg'



export const HeroSection = styled.section`
	height: 85vh;
	position: relative;
	overflow: hidden;
	padding-top: 60px;

	@media (max-width: 980px) {
		height: 80vh;
	}

	@media (max-width: 768px) {
		height: 90vh;
		// padding-top: 70px;
	}

	@media (max-width: 480px) {
		height: 90vh;
		// padding-top: 70px;
	}
`;

export const ClientSection = styled.section`
	background: #e1e4d5;
	padding: 20px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
	min-height: 15vh;

	@media (max-width: 980px) {
		padding: 15px 0;
		min-height: 20vh;
	}

	@media (max-width: 768px) {
		padding: 5px 0;
		min-height: 10vh;
	}

	@media (max-width: 480px) {
		padding: 5px 0;
		min-height: 10vh;
	}
`;

export const HeroVideo = styled.div`
	width: 100%;
	max-width: 1200px;
	background: linear-gradient(135deg, #066a67 0%, #066a67 100%);
	padding: 60px 40px;
	border-radius: 15px;
	box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
	margin: 0 auto;
	position: relative;
	z-index: 1;
	
	@media (max-width: 980px) {
		padding: 40px 30px;
		margin: 0 20px;
		border-radius: 10px;
	}
	
	@media (max-width: 768px) {
		padding: 30px 20px;
		margin: 0 15px;
		border-radius: 8px;
	}
	
	@media (max-width: 480px) {
		padding: 25px 15px;
		margin: 0 10px;
		border-radius: 8px;
	}
`;

export const HeroText = styled.p`
	margin-bottom: 35px;
	font-size: clamp(0.9rem, 1.5vw, 1.3rem);
	line-height: 24px;
	text-align: center;
	letter-spacing: 2px;
	color: #fff;
	
	@media (max-width: 768px) {
		font-size: clamp(0.8rem, 2vw, 1.1rem);
		line-height: 22px;
		letter-spacing: 1px;
		margin-bottom: 25px;
		padding: 0 10px;
	}
	
	@media (max-width: 480px) {
		font-size: clamp(0.75rem, 2.5vw, 1rem);
		line-height: 20px;
		letter-spacing: 0.5px;
		margin-bottom: 20px;
		padding: 0 5px;
	}
`;

export const ButtonWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	flex-flow: wrap;
	gap: 1rem;
	margin-top: 2rem;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		margin-top: 1.5rem;
	}

	@media (max-width: 480px) {
		gap: 0.8rem;
		margin-top: 1rem;
	}
`;

export const HeroButton = styled(Button)`
	color: black;
	&:before {
		background: #fff;
		height: 500%;
	}
	&:hover:before {
		height: 0%;
	}
	&:hover {
		color: white;
	}
`;